module.exports = __webpack_public_path__ + "static/media/transport.d6b3bc07.svg";